export const formatFloatTwoDecimals = (value: number | null | undefined): number => {
  if (typeof value !== `number`) return 0
  return parseFloat(value.toFixed(2))
}
